import { api_GET } from "api/axios.js";

const painel_api =
{
    getDashboardGroups: function(){
        const promise = new Promise((resolve, reject) => { 
            api_GET('Dashboard/GetDashboardGroups').then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getDashboardByGroup: function(grupo){
        const promise = new Promise((resolve, reject) => { 
            api_GET('Dashboard/GetDashboardByGroup/'+grupo).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
}

export default painel_api